import Route from './route.js';
import RouteMarker from '../markers/route-marker.js';

export default class ColorRoute extends Route {
    constructor(routeInfo, map, colorIndex, hideIcons, playbackIcon, disableRouteMarkers, fullRouteInfo) {
        super(routeInfo, map, colorIndex, hideIcons, playbackIcon, disableRouteMarkers, fullRouteInfo);
    };

    _createLayer() {
        let multiOptions = this._makeMultiOptionsObject(this.colorOptions);
        let colorPolyline = L.multiOptionsPolyline(this.coordsArray, {
            multiOptions: multiOptions,
            weight: this.config.routeLine.width,
            lineCap: 'round',
            interactive: false,
            opacity: 1,
            smoothFactor: 1
        });

        return colorPolyline;
    };

    _createRouteMarker(point) {
        let color = 'gray';
        return new RouteMarker(this.map, point, this.route.oid, this.allDistance, color);
    };

    _makeMultiOptionsObject(colorOptions) {
        let multiopts = {
            optionIdxFn: (latLng) => {
                return latLng[2];
            },
            options: colorOptions
        };
        return multiopts;
    };

    _fillCoordsArray(point) {
        let index = 0;

        if (!this.colorMap.has(point.width)) {
            this.colorMap.set(point.width, this.colorMapLastIndex);
            this.colorOptions.push({ color: '#' + point.width.toString(16).padStart(6, "0") });
            index = this.colorMapLastIndex;

            this.colorMapLastIndex++;
        }
        else {
            index = this.colorMap.get(point.width);
        }

        this.coordsArray.push([point.lat, point.lon, index]);
    };

    reduceIndex(index) {
        return index;
    };
}
